import { getEmptyImage } from 'react-dnd-html5-backend'

import { SubfolderFolderItemType } from 'types/folders'
import { DeckCardInfoType } from 'types/search'

import { useAppSelector } from 'redux/hooks'
import { useDeckDrag, useFolderDrag } from 'components/folderPage/folderHooks'
import {
  selectIsDeckMultiSelected,
  selectIsFolderMultiSelected,
  selectTotalMultiSelectedSize,
} from 'redux/folders/selectors'

import Icon from 'components/elements/Icon'

import styles from './dragHandle.module.scss'

type Props = {
  deck?: DeckCardInfoType
  folder: SubfolderFolderItemType
}

const DragHandle = ({ deck, folder }: Props) => {
  if (deck) return <DeckDragHandle deck={deck} />
  if (folder) return <FolderDragHandle folder={folder} />

  return null
}

export default DragHandle

const DeckDragHandle = ({ deck }: { deck: DeckCardInfoType }) => {
  const selected = useAppSelector(selectIsDeckMultiSelected(deck.id))
  const totalSelected = useAppSelector(selectTotalMultiSelectedSize)

  const [_collector, drag, preview] = useDeckDrag(deck, selected, totalSelected)

  if (typeof window !== 'undefined') preview(getEmptyImage(), { captureDraggingState: true })

  return drag(
    <button className={styles.dragHandle}>
      <Icon name="bars" />
    </button>,
  )
}

const FolderDragHandle = ({ folder }: { folder: SubfolderFolderItemType }) => {
  const selected = useAppSelector(selectIsFolderMultiSelected(folder.id))
  const totalSelected = useAppSelector(selectTotalMultiSelectedSize)

  const [_collector, drag] = useFolderDrag(folder, selected, totalSelected)

  return drag(
    <button className={styles.dragHandle}>
      <Icon name="bars" />
    </button>,
  )
}
